import React, { Component } from 'react';

import { Card, CardHeader, CardText, CardActions } from 'material-ui/Card';
import { List } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import { TiContacts as ContactIcon } from 'react-icons/ti';
import FlatButton from 'material-ui/FlatButton';

import { MdLocationCity as OfficeIcon } from 'react-icons/md';
import { FaMobile as MobileIcon } from 'react-icons/fa';

import { titleize, formatPhone, toTimeString } from 'helpers/Formatter';
import { expandCard } from 'helpers/ExpandGridCell';
import { AccentColor } from 'helpers/AccentColorHelper';

import { deepDiver } from 'helpers/utilities';

const style = {
  card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    transition: 'all .2s linear',
  },
  card_auto: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    transition: 'all .2s linear',
  },
  card_text: {
    padding: '15px 8px 0 8px',
    marginBottom: '200px',
    fontFamily: '"Circular", sans-serif !important',
  },
  subheader: {
    lineHeight: 0,
    padding: '20px 16px 10px 16px',
  },
  subheader_item: {
    margin: 0,
    fontSize: '15px',
  },
  subheader_side_padding: {
    padding: '0 16px',
  },
  no_padding: {
    padding: 0,
  },
  contact_card: {
    padding: 0,
    marginBottom: '20px',
  },
  card_actions: {
    padding: '8px',
    position: 'absolute',
    right: '1px',
    width: '99.3%',
    bottom: '1px',
    zIndex: 2,
    backgroundColor: 'white',
    textAlign: 'center',
    borderBottomLeftRadius: '6px',
    borderBottomRightRadius: '6px',
  },
  flat_button_color: {
    color: '#6F6F6F',
  },
};

const CONTAINER_HEIGHT_PX = 320;
class BuildingContactDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      componentHeight: `${CONTAINER_HEIGHT_PX}px`,
      isExpanded: false,
    };
  }

  displayContactCards = (contactCards = []) => {
    if (contactCards.length === 0) return null;

    return (
      <div className="row">
        {contactCards.map(contactCard => {
          return (
            <div className="col-lg-6">
              <Subheader inset={false} style={style.subheader}>
                {titleize(contactCard.contact_card_type)}
              </Subheader>
              <div className="col-xs-12" style={style.contact_card}>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>{contactCard.email}</p>
                  <p style={style.subheader_item}>{formatPhone(contactCard.phone_number)}</p>
                  {contactCard.contact_card_type === 'office' &&
                    contactCard.business_hours_start && (
                      <p style={style.subheader_item}>
                        Hours: {toTimeString(contactCard.business_hours_start)} -{' '}
                        {toTimeString(contactCard.business_hours_end)}
                      </p>
                    )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  displayAgents = (agents = []) => {
    if (agents.length === 0) return null;

    return (
      <div className="row">
        {agents.map(agent => {
          const office_number = agent.office_number_extension
            ? `${formatPhone(agent.office_number)} ext. ${agent.office_number_extension}`
            : formatPhone(agent.office_number);
          return (
            <div className="col-lg-6">
              <Subheader inset={false} style={style.subheader}>
                Agent
              </Subheader>
              <div className="col-xs-12" style={style.contact_card}>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>
                    {agent.first_name} {agent.last_name}
                  </p>
                  <p style={style.subheader_item}>{agent.email}</p>
                  <p style={style.subheader_item}>
                    <OfficeIcon size={16} /> {office_number}
                  </p>
                  <p style={style.subheader_item}>
                    <MobileIcon size={16} /> {formatPhone(agent.mobile_number)}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  displayNoContactCardDetails = (contactCards = [], agents = []) => {
    if (contactCards.length === 0 && agents.length === 0) {
      return (
        <div style={{ textAlign: 'center', marginTop: '15px' }}>
          <p style={{ fontSize: '15px' }}>No contact details.</p>
        </div>
      );
    }
  };

  render() {
    const building = this.props.building;
    let numOfContactCards = 0;
    if (building && building.contact_cards) {
      numOfContactCards += building.contact_cards.length;
    }
    if (building && building.agents) {
      numOfContactCards += building.agents.length;
    }

    style.card_header = {
      backgroundColor: '#fff',
      borderBottom: '1px solid #e0e0e0',
      width: '100%',
      padding: '11px 16px',
      fontFamily: 'Circular-Bold',
      backgroundImage: `-webkit-linear-gradient(left, ${AccentColor()}d6, ${AccentColor()}d6 49px, transparent 49px, transparent 100%)`,
    };

    const contactCards = deepDiver(building, 'contact_cards') || [];
    const agentCards = deepDiver(building, 'agents') || [];

    return (
      <div className="grid-column" ref="outerContactDetailsGrid" style={{ zIndex: 2 }}>
        <Card
          style={this.state.isExpanded ? style.card_auto : style.card}
          className="card"
          initiallyExpanded={false}
        >
          <CardHeader
            id="card-header"
            style={style.card_header}
            title={
              <span>
                <ContactIcon
                  size={18}
                  style={{ verticalAlign: 'middle', marginRight: '26px', color: 'white' }}
                />
                &nbsp;Contact Details ({numOfContactCards})
              </span>
            }
            actAsExpander={false}
            showExpandableButton={false}
          />
          {numOfContactCards > 2 && (
            <CardActions style={style.card_actions}>
              {this.state.isExpanded ? (
                <FlatButton
                  label={<span>Hide</span>}
                  primary={true}
                  style={style.flat_button_color}
                  onClick={() =>
                    expandCard(
                      this.refs.innerContactDetailsGrid,
                      this.refs.outerContactDetailsGrid,
                      this.state.isExpanded,
                      this,
                      CONTAINER_HEIGHT_PX
                    )}
                />
              ) : (
                <FlatButton
                  label={<span>More</span>}
                  primary={true}
                  style={style.flat_button_color}
                  onClick={() =>
                    expandCard(
                      this.refs.innerContactDetailsGrid,
                      this.refs.outerContactDetailsGrid,
                      this.state.isExpanded,
                      this,
                      CONTAINER_HEIGHT_PX
                    )}
                />
              )}
            </CardActions>
          )}

          <div ref="innerContactDetailsGrid">
            <CardText expandable={false} style={style.card_text}>
              <List style={style.no_padding}>
                {this.displayContactCards(contactCards)}
                {this.displayAgents(agentCards)}
                {this.displayNoContactCardDetails(contactCards, agentCards)}
              </List>
            </CardText>
          </div>
        </Card>
      </div>
    );
  }
}
export default BuildingContactDetails;
